// extracted by mini-css-extract-plugin
export default {"info":"Info_info__Rv1v+","map":"Info_map__nqVCW"};